// extracted by mini-css-extract-plugin
module.exports = {"filter":"_4Lb3Y","label":"du7Qi","inputs":"_6aQTo","input":"k89er","groups":"Fdrx7","delete":"_8YYwj"};